import React, { useState } from 'react';
import { OrderType } from 'types/OrderType';

export interface PrintOrderContextProps {
  order?: OrderType;
  setOrder: React.Dispatch<React.SetStateAction<OrderType | undefined>>;
  isDealer: boolean;
  setIsDealer: React.Dispatch<React.SetStateAction<boolean>>;
}
export const PrintContext = React.createContext<PrintOrderContextProps>({} as PrintOrderContextProps);
export function usePrintContext(): PrintOrderContextProps {
  const [order, setOrder] = useState<OrderType>();
  const [isDealer, setIsDealer] = useState<boolean>(false);
  return {
    order,
    setOrder,
    isDealer,
    setIsDealer,
  };
}
